import { VFlex } from '../VFlex';
import PickListProvider from './Provider';
import VGroupItemList from './VGroupItemList';
import VGroupList from './VGroupList';
import VPickedItemList from './VPickedItemList';
import style from './style';
import type { BaseGroup, BaseItem, VPickListProp } from './type';

const VPickList = <
  I extends BaseItem = BaseItem,
  G extends BaseGroup<I> = BaseGroup<I>,
>(
  props: VPickListProp<I, G>,
) => {
  return (
    <PickListProvider {...props}>
      <VFlex className={style.pickListGroup}>
        <VFlex className={style.groupItemContainer}>
          <VGroupList groupListTitle={props.groupListTitle} />
          <div className={style.groupItemDivider} />
          <VGroupItemList
            itemListTitle={props.itemListTitle}
            searchInputPlaceHoder={props.searchInputPlaceHoder}
            groupAllText={props.groupAllText}
          />
        </VFlex>
        <VPickedItemList
          pickedItemListTitle={props.pickedItemListTitle}
          confirmButtonText={props.confirmButtonText}
          onConfirm={
            props.onConfirm
              ? items => props.onConfirm?.(items as I[])
              : undefined
          }
        />
      </VFlex>
    </PickListProvider>
  );
};

export default VPickList;
